// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert-banner[data-v-58a63ff4]{background-color:#a41a26;color:#fff;padding:.5rem;text-align:center}.alert-banner b[data-v-58a63ff4]{font-size:1.2rem}.alert-banner p[data-v-58a63ff4]{font-size:.9rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
